module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-SemiBoldItalic.8f2c555.woff2";